import { colors } from '../../colors';
var socialFeed = {
  postTextColor: colors.graphite,
  primaryColor: colors.whiteish,
  feedBgColor: colors.white,
  headlineUppercase: false,
  subHeadlineUppercase: true
};
export default socialFeed;